import GetAppIcon from '@material-ui/icons/GetApp'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import Export from 'Components/UI/Organisms/Sales/Cobranzas/Export'

import TemplateGlobal from '../../Common'

const CobranzasTemplate = () => {
  const { state, setOpen, setClose } = SetState()

  const BUTTONS = [
    {
      menuIcon: <GetAppIcon fontSize="small" />,
      menuTitle: 'Descargar',
      buttonContent: <GetAppIcon />,
      onClick: setOpen,
    },
  ]
  return (
    <TemplateGlobal
      navbar={<NavBarGlobal title="Ventas" subTitle="Cobranzas" buttons={BUTTONS} />}
      table={<>{state.suspense && <Export open={state.open} onClose={setClose} />}</>}
    />
  )
}

export default CobranzasTemplate
